import React from 'react';
import { motion, Variants } from 'framer-motion';

export const overlayVariants: Variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.15 } }
};

export const contentVariants: Variants = {
    hidden: { scale: 0.95, opacity: 0, y: 10 },
    visible: { 
        scale: 1, 
        opacity: 1, 
        y: 0,
        transition: { type: 'spring', stiffness: 300, damping: 25 } 
    },
    exit: { scale: 0.95, opacity: 0, transition: { duration: 0.1 } }
};

interface ModalWrapperProps {
    children: React.ReactNode;
    onClose: () => void;
    borderColor: string;
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({ children, onClose, borderColor }) => {
    const modalOverlayStyle: React.CSSProperties = { 
        position: 'fixed', 
        top: 0, bottom: 0, left: '50%',
        transform: 'translateX(-50%)',
        width: '100%',
        maxWidth: '500px',
        backgroundColor: 'rgba(0,0,0,0.95)', 
        zIndex: 10000, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '20px' 
    };
    const modalContentStyle: React.CSSProperties = { 
        backgroundColor: '#121212', 
        border: '1px solid #222', 
        borderRadius: '16px', 
        padding: '25px', 
        width: '100%', 
        maxWidth: '400px', 
        textAlign: 'center' 
    };

    return (
        <motion.div 
            initial="hidden" animate="visible" exit="hidden" 
            variants={overlayVariants} 
            style={modalOverlayStyle}
            onClick={(e) => e.target === e.currentTarget && onClose()}
        >
            <motion.div 
                variants={contentVariants} 
                style={{ ...modalContentStyle, borderColor }}
            >
                {children}
            </motion.div>
        </motion.div>
    );
};
